import { connect } from 'react-redux';

import { injectIntl, useIntl } from 'react-intl';
import { getContractFields, getFieldErrors } from '~/reducers/workflow';
import PageLayout from '~/ui/components/PageLayout/PageLayout';

import EmptySectionItem from './EmptySectionItem';
import FieldSectionItem from './FieldSectionItem';
import { getErrorMessage } from './utils';

function ContractFieldSection({
  // connected
  fields,
  errors,
  fieldMapping,
}) {
  const intl = useIntl();

  return (
    <PageLayout.SidebarSection
      title={intl.formatMessage({
        id: 'ContractFieldSection.contractSectionTitle',
        defaultMessage: 'Contract',
        description: 'Title for contract fields section',
      })}
    >
      {fields.length === 0 ? (
        <EmptySectionItem />
      ) : (
        fields.map((field) => (
          <FieldSectionItem
            key={field.id}
            field={field}
            errorMessage={getErrorMessage(errors, field.id, fieldMapping, intl)}
            isAssigned
          />
        ))
      )}
    </PageLayout.SidebarSection>
  );
}

function mapStateToProps({ workflow, builder }, { intl }) {
  return {
    fields: getContractFields(workflow),
    errors: getFieldErrors(workflow, builder, intl),
    fieldMapping: workflow.settings.dataFieldsMapping,
  };
}

export default injectIntl(connect(mapStateToProps)(ContractFieldSection));
